import { login, logout, getInfo } from "@/api/login";
import { getToken, setToken, removeToken } from "@/utils/auth";
// import defAva from "@/assets/images/profile.jpg";
// import md5 from "js-md5";
const useUserStore = defineStore("user", {
  state: () => ({
    token: getToken(),
    avatar: "https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg",
    roles: [],
    permissions: [],
    userInfo: JSON.parse(localStorage.getItem("userInfo")) || {} //userType:4为教育局
  }),
  actions: {
    // 登录
    login(params) {
      // const code = userInfo.code
      // const uuid = userInfo.uuid

      return new Promise(async (resolve, reject) => {
        login(params).then(res => {
          setToken(res.data.accessToken);
          this.token = res.data.accessToken;
          localStorage.setItem("userInfo", JSON.stringify(res.data));
          this.userInfo = res.data;
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 获取用户信息
    async getInfo() {
      const {
        code,
        data
      } = await getInfo();
      if (code == "success") {
        // console.log(data);
        this.roles = [1, 2, 3, 4];
        this.userInfo = Object.assign(this.userInfo, data);
        return true;
      } else {
        return false;
      }
    },
    // 退出系统
    logOut() {
      return new Promise((resolve, reject) => {
        this.token = "";
        removeToken();
        resolve();
        // logout(this.token).then(() => {
        //   this.token = ''
        //   this.roles = []
        //   this.permissions = []
        //   removeToken()
        //   resolve()
        // }).catch(error => {
        //   reject(error)
        // })
      });
    }
  }
});
export default useUserStore;